const PROMO_CODE_ERRORS = {
	565: "Промокод не найден или недействителен",
	566: "Промокод уже активирован",
	567: "Вы уже активировали промокод этого мероприятия",
};

export const PENDING_PROMO_CODE_KEY = "pending_promo_code";

export const savePendingPromoCode = (code) => {
	if (typeof window === "undefined") {
		return;
	}

	localStorage.setItem(PENDING_PROMO_CODE_KEY, code.trim());
};

export const getPendingPromoCode = () => {
	if (typeof window === "undefined") {
		return "";
	}

	return localStorage.getItem(PENDING_PROMO_CODE_KEY) || "";
};

export const clearPendingPromoCode = () => {
	if (typeof window === "undefined") {
		return;
	}

	localStorage.removeItem(PENDING_PROMO_CODE_KEY);
};

export const getPromoCodeErrorMessage = (error) => {
	const status = error?.response?.status;

	if (PROMO_CODE_ERRORS[status]) {
		return PROMO_CODE_ERRORS[status];
	}

	return error?.response?.data?.detail || "Не удалось активировать промокод";
};
